import { Logo, WhatsAppIcon } from "./Brand";
import { PHONE_LABEL } from "../../lib/site";
import { useQuiz } from "../../hooks/QuizContext";
import { MapPin } from "lucide-react";

export const Footer = () => {
  const { openQuiz } = useQuiz();
  return (
    <footer className="bg-[#FAF5EE] py-12" data-testid="site-footer">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-8 px-5 sm:px-8 md:flex-row md:items-center md:justify-between lg:px-12">
        <Logo id="lotus-footer" />
        <div className="flex flex-col gap-2.5 text-sm text-[#6B5650] md:text-right">
          <button
            type="button"
            onClick={() => openQuiz("footer")}
            className="inline-flex items-center gap-2 font-semibold text-[#2D1C18] hover:text-[#9A4A38] md:justify-end cursor-pointer"
            data-testid="footer-whatsapp-link"
          >
            <WhatsAppIcon className="h-4 w-4" /> {PHONE_LABEL}
          </button>
          <a
            href="https://www.google.com/maps/search/?api=1&query=Pra%C3%A7a+Enfermeira+Geralda+Marra%2C+100+-+S%C3%A3o+Jo%C3%A3o+Batista%2C+Belo+Horizonte+-+MG"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-xs text-[#6B5650] hover:text-[#9A4A38] transition-colors md:justify-end"
            data-testid="footer-address"
          >
            <MapPin className="h-3.5 w-3.5 shrink-0 text-[#9A4A38]" />
            <span>Praça Enfermeira Geralda Marra, 100 - São João Batista, Belo Horizonte - MG</span>
          </a>
          <div className="flex items-center gap-3 md:justify-end pt-1">
            <p>© {new Date().getFullYear()} Aisla Studio. Todos os direitos reservados.</p>
            <span className="text-[#6B5650]/40">·</span>
            <a href="#admin" className="text-xs text-[#9A7A72] hover:text-[#2D1C18] transition-colors" data-testid="footer-admin-link">
              Painel Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
